require('../../modules/es6.object.keys');
module.exports = require('../../modules/_core').Object.keys;



//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/fn/object/keys.js
// module id = 52
// module chunks = 0


// WEBPACK FOOTER //
// webpack:///~/core-js/library/fn/object/keys.js